module.exports = new __parcel__URL__("paladin.f1958368.png").toString();